export type IconType = 'snap' | 'globe' | 'phone';

export function iconForFamily(family: string): IconType {
  if (family === 'Specs') return 'snap';
  if (family === 'Web') return 'globe';
  return 'phone';
}
